import { Checkbox } from '@material-ui/core';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import React from 'react';

const styles = {
    root: {
        padding: 0,
        color: 'white',
        '&$checked': {
            color: '#0d83c9',
        },
    },
    checked: {},
    classLabel: {
        color: 'white'
    }
};

export interface IProps extends WithStyles<typeof styles> {
    name: string,
    value: boolean,
    onChange?: (event: any) => void,
    isReadonly: boolean,
}

const CheckBox = (props: IProps) => {
    return (
        <Checkbox
            name = {props.name}
            readOnly = {props.isReadonly}
            icon={<CheckBoxOutlineBlankIcon fontSize="inherit" />}
            checkedIcon={<CheckBoxIcon fontSize="inherit" />}
            checked={props.value}
            onChange={props.onChange}
            classes={{
                root: props.classes.root,
                checked: props.classes.checked
            }}
        />
    )
};

export default withStyles(styles)(CheckBox);